import {MutableRefObject, useEffect, useRef} from 'react';

/**
 * React hook to track if the component has been unmounted.
 *
 * Why, you ask, do we track "is not unmounted" instead of the obviously simpler "is mounted"?
 * The answer is that the first tick will not give correct results in the "is mounted" case.
 *
 * Otherwise, this should be functionally identical to (and strictly better than) "useIsMounted".
 */
export default function useIsNotUnmounted(): MutableRefObject<boolean> {
  const isMounted = useRef(true);
  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);
  return isMounted;
}
